import(/* webpackMode: "eager" */ "/app/next/app/[root]/(bare)/(client-data)/error.tsx");
